const data=[
	{
	  "id": 1,
	  "region": "AFRICA",
	  "country": "Algeria",
	  "name": "El Djamila",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 2.901,
	  "lat": 36.799,
	  "text_align": 8,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 6
	},
	{
	  "id": 2,
	  "region": "AFRICA",
	  "country": "Angola",
	  "name": "Cacuaco",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 13.37,
	  "lat": -8.777,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 3,
	  "region": "LATAM",
	  "country": "Argentina",
	  "name": "Buenos Aires",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 3,
	  "capacity": 4,
	  "colocation": 2,
	  "lon": -58.437,
	  "lat": -34.608,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 6
	},
	{
	  "id": 4,
	  "region": "LATAM",
	  "country": "Argentina",
	  "name": "Mendoza",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -68.846,
	  "lat": -32.889,
	  "text_align": 6,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 5,
	  "region": "LATAM",
	  "country": "Argentina",
	  "name": "Las Toninas",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -56.705,
	  "lat": -36.488,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 6
	},
	{
	  "id": 7,
	  "region": "AFRICA",
	  "country": "Benin",
	  "name": "Cotonou",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 2.425,
	  "lat": 6.368,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 6
	},
	{
	  "id": 8,
	  "region": "LATAM",
	  "country": "Brazil",
	  "name": "Fortaleza",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -38.522,
	  "lat": -3.73,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 9,
	  "region": "LATAM",
	  "country": "Brazil",
	  "name": "Rio de Janeiro",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 2,
	  "capacity": 4,
	  "colocation": 2,
	  "lon": -43.209,
	  "lat": -22.911,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 10,
	  "region": "LATAM",
	  "country": "Brazil",
	  "name": "Salvador",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -38.502,
	  "lat": -12.978,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 11,
	  "region": "LATAM",
	  "country": "Brazil",
	  "name": "Santos",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -46.291,
	  "lat": -23.961,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 12,
	  "region": "LATAM",
	  "country": "Brazil",
	  "name": "São Paulo",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 3,
	  "capacity": 5,
	  "colocation": 1,
	  "lon": -49.023,
	  "lat": -21.955,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 13,
	  "region": "AFRICA",
	  "country": "Camerun",
	  "name": "Douala",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 9.664,
	  "lat": 4.054,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 15,
	  "region": "LATAM",
	  "country": "Chile",
	  "name": "Arica",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -70.321,
	  "lat": -18.479,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 16,
	  "region": "LATAM",
	  "country": "Chile",
	  "name": "Santiago",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 3,
	  "capacity": 5,
	  "colocation": 2,
	  "lon": -70.65,
	  "lat": -33.438,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 17,
	  "region": "LATAM",
	  "country": "Chile",
	  "name": "Valparaiso",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -71.62,
	  "lat": -33.046,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 18,
	  "region": "LATAM",
	  "country": "Colombia",
	  "name": "Barranquilla",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -74.809,
	  "lat": 11.012,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 19,
	  "region": "LATAM",
	  "country": "Colombia",
	  "name": "Bogotá",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -74.076,
	  "lat": 4.598,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 20,
	  "region": "LATAM",
	  "country": "Colombia",
	  "name": "Cartagena",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -75.5,
	  "lat": 9.5,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 21,
	  "region": "LATAM",
	  "country": "Costa rica",
	  "name": "San Jose",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -84.077,
	  "lat": 9.913,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 23,
	  "region": "LATAM",
	  "country": "Dominican Republic",
	  "name": "Punta Cana",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -68.423,
	  "lat": 18.563,
	  "text_align": 4,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 24,
	  "region": "LATAM",
	  "country": "Ecuador",
	  "name": "Manta",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -80.822,
	  "lat": -1.032,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 25,
	  "region": "LATAM",
	  "country": "Ecuador",
	  "name": "Salinas",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -80.927,
	  "lat": -2.256,
	  "text_align": 6,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 6
	},
	{
	  "id": 26,
	  "region": "LATAM",
	  "country": "El Salvador",
	  "name": "San Salvador",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -89.191,
	  "lat": 13.699,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 27,
	  "region": "EMEA",
	  "country": "France",
	  "name": "Paris",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 2,
	  "capacity": 2,
	  "colocation": 0,
	  "lon": 2.352,
	  "lat": 48.857,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 28,
	  "region": "EMEA",
	  "country": "France",
	  "name": "Marsella",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 5.37,
	  "lat": 43.296,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 29,
	  "region": "AFRICA",
	  "country": "Gabon",
	  "name": "Libreville",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 9.454,
	  "lat": 0.39,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 91,
	  "region": "EMEA",
	  "country": "France",
	  "name": "Saint-Hilaire-de-Riez",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -1.975,
	  "lat": 46.726,
	  "text_align": 6,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 31,
	  "region": "EMEA",
	  "country": "Germany",
	  "name": "Dusseldorf",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 6.776,
	  "lat": 51.225,
	  "text_align": 3,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 32,
	  "region": "EMEA",
	  "country": "Germany",
	  "name": "Frankfurt",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 2,
	  "capacity": 2,
	  "colocation": 0,
	  "lon": 8.682,
	  "lat": 50.111,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 35,
	  "region": "AFRICA",
	  "country": "Ghana",
	  "name": "Accra",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -0.206,
	  "lat": 5.56,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 36,
	  "region": "LATAM",
	  "country": "Guatemala",
	  "name": "Guatemala",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -90.513,
	  "lat": 14.642,
	  "text_align": 1,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 37,
	  "region": "LATAM",
	  "country": "Guatemala",
	  "name": "Puerto San Jose",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -90.834,
	  "lat": 13.93,
	  "text_align": 4,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 38,
	  "region": "LATAM",
	  "country": "Guatemala",
	  "name": "Puerto Barrios",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -88.435,
	  "lat": 15.836,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 40,
	  "region": "AFRICA",
	  "country": "Ivory Coast",
	  "name": "Abidjan",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -4.042,
	  "lat": 5.409,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 41,
	  "region": "EMEA",
	  "country": "Netherlands",
	  "name": "Amsterdam",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 4.898,
	  "lat": 52.375,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 42,
	  "region": "LATAM",
	  "country": "Netherlands",
	  "name": "Aruba",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -69.961,
	  "lat": 12.49,
	  "text_align": 2,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 43,
	  "region": "LATAM",
	  "country": "Netherlands",
	  "name": "Curaçao",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -68.964,
	  "lat": 12.185,
	  "text_align": 6,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 44,
	  "region": "LATAM",
	  "country": "Nicaragua",
	  "name": "Managua",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -86.274,
	  "lat": 12.146,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 45,
	  "region": "AFRICA",
	  "country": "Nigeria",
	  "name": "Lagos",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 3.394,
	  "lat": 6.455,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 6
	},
	{
	  "id": 46,
	  "region": "LATAM",
	  "country": "Panama",
	  "name": "Balboa",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -79.534,
	  "lat": 8.971,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 47,
	  "region": "LATAM",
	  "country": "Peru",
	  "name": "Lima",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 2,
	  "colocation": 1,
	  "lon": -77.042,
	  "lat": -11.046,
		"old_lat": -12.062,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 6
	},
	{
	  "id": 48,
	  "region": "LATAM",
	  "country": "Peru",
	  "name": "Lurin",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -76.878,
	  "lat": -12.277,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 20
	},
	{
	  "id": 49,
	  "region": "LATAM",
	  "country": "Peru",
	  "name": "Mancora",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -81.045,
	  "lat": -4.103,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 6
	},
	{
	  "id": 52,
	  "region": "EMEA",
	  "country": "Portugal",
	  "name": "Sesimbra",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -9.119,
	  "lat": 38.496,
	  "text_align": 4,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 12
	},
	{
	  "id": 54,
	  "region": "USA",
	  "country": "Puerto Rico",
	  "name": "San Juan",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -66.413,
	  "lat": 18.221,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 55,
	  "region": "AFRICA",
	  "country": "Senegal",
	  "name": "Dakar",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -17.448,
	  "lat": 14.693,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 56,
	  "region": "AFRICA",
	  "country": "South Africa",
	  "name": "Melkbosstrand",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 18.446,
	  "lat": -33.722,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 57,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Barcelona",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 2,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 2.2,
	  "lat": 41.7,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 6
	},
	{
	  "id": 58,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Madrid",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 7,
	  "capacity": 3,
	  "colocation": 0,
	  "lon": -3.704,
	  "lat": 40.417,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 6
	},
	{
	  "id": 59,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Estepona",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -5.147,
	  "lat": 36.427,
	  "text_align": 2,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 61,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Ses Covetes",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 2.97,
	  "lat": 39.355,
	  "text_align": 8,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 62,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Conil",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -6,
	  "lat": 36.5,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 63,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Sopelana",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -3.25,
	  "lat": 43.38,
	  "text_align": 2,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 12
	},
	{
	  "id": 64,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Altavista",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -15.4,
	  "lat": 27.923,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 65,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Palma",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": 2.65,
	  "lat": 39.57,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 66,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Chipiona",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -6.7,
		"lat": 37,
	  "text_align": 4,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 67,
	  "region": "AFRICA",
	  "country": "Morocco",
	  "name": "Tetuan",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -5.363,
	  "lat": 35.589,
	  "text_align": 8,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 68,
	  "region": "AFRICA",
	  "country": "Spain",
	  "name": "Melilla",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -2.938,
	  "lat": 35.292,
	  "text_align": 6,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 69,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Roquetas",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -2.615,
	  "lat": 36.764,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 70,
	  "region": "EMEA",
	  "country": "United Kingdom",
	  "name": "London",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 2,
	  "capacity": 2,
	  "colocation": 0,
	  "lon": -0.128,
	  "lat": 51.507,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 71,
	  "region": "LATAM",
	  "country": "United Kingdom",
	  "name": "Tortola",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -64.639,
	  "lat": 18.421,
	  "text_align": 6,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 8
	},
	{
	  "id": 72,
	  "region": "LATAM",
	  "country": "United States",
	  "name": "St. Croix",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -64.835,
	  "lat": 17.725,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 73,
	  "region": "USA",
	  "country": "United States",
	  "name": "Dallas",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -96.797,
	  "lat": 32.776,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 74,
	  "region": "USA",
	  "country": "United States",
	  "name": "Jacksonville",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 2,
	  "colocation": 1,
	  "lon": -81.4,
	  "lat": 30.332,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 75,
	  "region": "USA",
	  "country": "United States",
	  "name": "Laredo",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -99.509,
	  "lat": 27.506,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 76,
	  "region": "USA",
	  "country": "United States",
	  "name": "McAllen",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 0,
		"colocation": 0,
	  "lon": -98.23,
	  "lat": 26.204,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 77,
	  "region": "USA",
	  "country": "United States",
	  "name": "Miami",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 2,
	  "capacity": 2,
	  "colocation": 0,
	  "lon": -80.194,
	  "lat": 25.774,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 78,
	  "region": "USA",
	  "country": "United States",
	  "name": "Boca Raton",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -80.083,
	  "lat": 26.359,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 79,
	  "region": "USA",
	  "country": "United States",
	  "name": "New York",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -73.987,
	  "lat": 40.731,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 81,
	  "region": "USA",
	  "country": "United States",
	  "name": "Ashburn",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 2,
	  "colocation": 0,
	  "lon": -77.487,
	  "lat": 39.044,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 82,
	  "region": "USA",
	  "country": "United States",
	  "name": "Virginia Beach",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 1,
	  "lon": -75.977,
	  "lat": 36.853,
	  "text_align": 6,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 4
	},
	{
	  "id": 84,
	  "region": "LATAM",
	  "country": "Uruguay",
	  "name": "Maldonado",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -54.9,
	  "lat": -34.5,
	  "text_align": 6,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 6
	},
	{
	  "id": 89,
	  "region": "LATAM",
	  "country": "Panama",
	  "name": "María Chiquita",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -79.753,
	  "lat": 9.441,
	  "text_align": 2,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 16
	},
	{
	  "id": 90,
	  "region": "USA",
	  "country": "United States",
	  "name": "Phoenix",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -112.071,
	  "lat": 33.451,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 87,
	  "region": "EMEA",
	  "country": "Spain",
		"name": "Derio",
	  "pop": 1,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 1,
	  "capacity": 3,
	  "colocation": 1,
	  "lon": -2.935,
	  "lat": 43.261,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 1,
	  "zoom": 12
	},
	{
	  "id": 96,
	  "region": "LATAM",
	  "country": "Panama",
	  "name": "Panamá",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 1,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -80.5,
	  "lat": 8.65,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 97,
	  "region": "USA",
	  "country": "United States",
	  "name": "Richmond",
	  "pop": 1,
	  "ls": 0,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -77.501,
	  "lat": 37.51,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 4
	},
	{
	  "id": 98,
	  "region": "EMEA",
	  "country": "Spain",
	  "name": "Valencia",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 0,
	  "internet": 0,
	  "capacity": 0,
	  "colocation": 0,
	  "lon": -0.377,
	  "lat": 39.469,
	  "text_align": 8,
	  "dot": 0,
	  "ls_cable": 0,
	  "zoom": 8
	},
	{
	  "id": 99,
	  "region": "LATAM",
	  "country": "Mexico",
	  "name": "Cancun",
	  "pop": 0,
	  "ls": 1,
	  "ls_telxius": 1,
	  "internet": 0,
	  "capacity": 1,
	  "colocation": 0,
	  "lon": -86.94,
	  "lat": 21.17,
	  "text_align": 2,
	  "dot": 1,
	  "ls_cable": 1,
	  "zoom": 8,
	  "finished": 1
	},
	{
		"id": 100,
		"region": "EMEA",
		"country": "Spain",
		"name": "Zaragoza",
		"pop": 0,
		"ls": 1,
		"ls_telxius": 0,
		"internet": 0,
		"capacity": 0,
		"colocation": 0,
		"lon": -0.87,
		"lat": 41.65,
		"text_align": 2,
		"dot": 0,
		"ls_cable": 0,
		"zoom": 8,
		"planned": 1
	}
  ]

  export default data
